module.exports = __webpack_public_path__ + "static/cookie-6ac16e4e8a42198ce106d2eadea1edc0.jpg";